import BASE_URL from "./baseUrl";

// Routes for API calls

export const LOGIN_ROUTE = `${BASE_URL}/auth/login`;
export const PROFILE_ROUTE = `${BASE_URL}/auth/me`;
export const LOGOUT_ROUTE = `${BASE_URL}/auth/logout`;
export const CHANGEPASSWORD_ROUTE = `${BASE_URL}/auth/change-password`;

// Routes for Dashboard data
export const DASHBOARDSTATS_ROUTE = `${BASE_URL}/admin/dashboard`;

// Routes for Games Management
export const GET_ALL_GAMES_ROUTE = `${BASE_URL}/games`;
export const CREATE_GAME_ROUTE = `${BASE_URL}/games`;
export const UPDATE_GAME_ROUTE = (game_id) => `${BASE_URL}/games/${game_id}`;
export const DELETE_GAME_ROUTE = (game_id) => `${BASE_URL}/games/${game_id}`;

// Routes for Transactions Management
export const GET_ALL_TRANSACTIONS_ROUTE = `${BASE_URL}/admin/transactions`;
export const GET_TRANSACTION_DETAILS_ROUTE = (transaction_id) => `${BASE_URL}/admin/transactions/${transaction_id}`;

// Routes for Session Management
export const GET_SESSIONS_ROUTE = `${BASE_URL}/admin/sessions`;
export const GET_SESSION_DELETE_ROUTE = (session_id) => `${BASE_URL}/admin/sessions/${session_id}`;

// Routes for Social Media Management
export const GET_PUBLIC_SOCIAL_ROUTE = `${BASE_URL}/social`;
export const GET_ALL_SOCIAL_ROUTE = `${BASE_URL}/admin/social`;
export const CREATE_SOCIAL_ROUTE = `${BASE_URL}/admin/social`;
export const UPDATE_SOCIAL_ROUTE = (id) => `${BASE_URL}/admin/social/${id}`;
export const TOGGLE_SOCIAL_ROUTE = (id) => `${BASE_URL}/admin/social/${id}/toggle`;
export const DELETE_SOCIAL_ROUTE = (id) => `${BASE_URL}/admin/social/${id}`;